import { render, staticRenderFns } from "./PhoneCreator.vue?vue&type=template&id=525df84a&scoped=true&"
import script from "./PhoneCreator.vue?vue&type=script&lang=js&"
export * from "./PhoneCreator.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCreator.vue?vue&type=style&index=0&id=525df84a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525df84a",
  null
  
)

export default component.exports